import type { FC, ReactElement } from "react";
import { useMemo } from "react";

import type { IconName } from "@similarweb/icons";
import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";

import {
    StyledAccessBanner,
    StyledBannerBtnWrapper,
    StyledBannerContent,
    StyledBannerContentDescription,
    StyledBannerContentTitle,
    StyledIconWrapper,
} from "./styles";

type GrandAccessBannerProps = {
    title: string;
    description: string;
    button: ReactElement;
    iconName?: IconName;
    iconImagePath?: string;
};

const GrandAccessBanner: FC<GrandAccessBannerProps> = ({ title, description, iconImagePath, button, iconName }) => {
    const icon = useMemo(() => {
        if (iconName) {
            return (
                <SWReactIcons
                    iconName={iconName}
                    size="24px"
                    iconColor={colorsPalettes.indigo[300]}
                />
            );
        }

        if (iconImagePath) {
            return <img src={iconImagePath} />;
        }

        return null;
    }, [iconImagePath, iconName]);

    return (
        <StyledAccessBanner>
            {icon ? <StyledIconWrapper>{icon}</StyledIconWrapper> : null}
            <StyledBannerContent>
                <StyledBannerContentTitle>{title}</StyledBannerContentTitle>
                <StyledBannerContentDescription>{description}</StyledBannerContentDescription>
                <StyledBannerBtnWrapper>{button}</StyledBannerBtnWrapper>
            </StyledBannerContent>
        </StyledAccessBanner>
    );
};

export default GrandAccessBanner;
